/* ETB Kayan koleksiyonlar — Concept (jsco-yeni) portu.
   Bağımsız vanilla JS; tema global'lerine dayanmaz. Kaynak davranış birebir:
   sekme geçişinde eski şerit AKMAYA DEVAM EDEREK söner, yenisi üstüne biner.
   Hız px/sn cinsinden sabittir (şerit uzunluğundan bağımsız). */
(function () {
  'use strict';
  if (window.__etbcmLoaded) return;
  window.__etbcmLoaded = true;

  function init(root) {
    if (!root || root.dataset.etbcmInit) return;
    root.dataset.etbcmInit = '1';
    var speed = Math.max(5, parseFloat(root.dataset.speed) || 45); /* px/sn */
    var viewport = root.querySelector('[data-etbcm-viewport]');
    var tabs = [].slice.call(root.querySelectorAll('[data-etbcm-tab]'));
    var ink = root.querySelector('.etbcm-ink');
    var active = -1, current = null, fading = [];
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!viewport) return;

    function tpl(i) { return root.querySelector('template[data-etbcm-cat="' + i + '"]'); }

    /* Bir set kopyası; kopya sayısı ekranı fazlasıyla dolduracak kadar artırılır.
       Kaydırma mesafesi = tek set genişliği (px) → hız, içerikten bağımsız px/sn sabit. */
    function buildLayer(i) {
      var t = tpl(i);
      if (!t) return null;
      var layer = document.createElement('div');
      layer.className = 'etbcm-layer';
      var track = document.createElement('div');
      track.className = 'etbcm-track';
      var set = document.createElement('div');
      set.className = 'etbcm-set';
      set.appendChild(t.content.cloneNode(true));
      track.appendChild(set);
      layer.appendChild(track);
      viewport.appendChild(layer);
      // 22 Eki (hız): şerit görselleri açılışta değil, şerit ekrana yaklaşınca (800px önce) yüklenir
      (function (L, R) { var go = function () { L.querySelectorAll('img').forEach(function (im) { im.loading = 'eager'; }); }; if (!('IntersectionObserver' in window)) { go(); return; } var io = new IntersectionObserver(function (e) { if (e.some(function (x) { return x.isIntersecting; })) { io.disconnect(); go(); } }, { rootMargin: '800px 0px' }); io.observe(R); })(layer, root);
      var setW = set.offsetWidth;
      var vw = viewport.offsetWidth || root.offsetWidth;
      if (setW < 10) { setW = 10; }
      var copies = Math.max(2, Math.ceil(vw / setW) + 1);
      for (var k = 1; k < copies; k++) track.appendChild(set.cloneNode(true));
      track.style.setProperty('--etbcm-shift', setW);
      track.style.setProperty('--etbcm-dur', (setW / speed) + 's');
      return layer;
    }

    function placeInk(btn) {
      if (!ink || !btn) return;
      ink.style.width = btn.offsetWidth + 'px';
      ink.style.transform = 'translateX(' + btn.offsetLeft + 'px)';
    }

    function activate(i, instant) {
      if (i === active) return;
      active = i;
      tabs.forEach(function (b, j) { b.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
      var btn = tabs[i];
      if (btn) {
        placeInk(btn);
        if (!instant && btn.scrollIntoView) btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
      var old = current;
      var layer = buildLayer(i);
      current = layer;
      if (!layer) return;
      if (instant || reduced) {
        layer.classList.add('is-in');
        if (old) old.remove();
        return;
      }
      /* Çapraz geçiş: eski katman AKMAYA DEVAM EDEREK söner, yenisi üstünde belirir. */
      requestAnimationFrame(function () { requestAnimationFrame(function () { layer.classList.add('is-in'); }); });
      if (old) {
        old.classList.remove('is-in');
        old.classList.add('is-out');
        fading.push(old);
        setTimeout(function () { var x = fading.shift(); if (x) x.remove(); }, 650);
      }
    }

    tabs.forEach(function (b) {
      b.addEventListener('click', function () { activate(parseInt(b.dataset.etbcmTab, 10), false); });
    });

    /* Ekran dışındayken durdur (görünmez yerde boşa çalışmasın) */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { root.classList.toggle('etbcm-offscreen', !e.isIntersecting); });
      }, { rootMargin: '100px' }).observe(root);
    }

    /* Yeniden boyutlanınca aktif şerit yeniden kurulur (kopya sayısı/hız korunur) */
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        if (active < 0 || !root.isConnected) return;
        var keep = active; active = -1;
        if (current) { current.remove(); current = null; }
        activate(keep, true);
      }, 200);
    });

    /* Tema düzenleyici: kategori bloğu seçilince o sekme açılır */
    document.addEventListener('shopify:block:select', function (e) {
      if (!root.contains(e.target)) return;
      var idx = tabs.indexOf(e.target);
      if (idx > -1) activate(idx, false);
    });

    activate(0, true);
    if (tabs[0]) placeInk(tabs[0]);
    /* Diğer sekmelerin görsellerini boşta önceden ısıt — geçişte boş kart görünmesin */
    (window.requestIdleCallback || function (f) { setTimeout(f, 1500); })(function () {
      root.querySelectorAll('template[data-etbcm-cat]').forEach(function (t) {
        t.content.querySelectorAll('img').forEach(function (im) {
          var s = new Image();
          if (im.getAttribute('srcset')) s.srcset = im.getAttribute('srcset');
          if (im.getAttribute('sizes')) s.sizes = im.getAttribute('sizes');
          s.src = im.getAttribute('src');
        });
      });
    });
    window.addEventListener('load', function () { if (tabs[active]) placeInk(tabs[active]); });
  }

  function initAll(scope) {
    [].slice.call((scope || document).querySelectorAll('[data-etbcm]')).forEach(init);
    if (scope && scope.matches && scope.matches('[data-etbcm]')) init(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  /* Tema düzenleyicide section yeniden basılınca tekrar kur */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
